import React, { Component, } from 'react'

import { connect } from 'react-redux';
import {bindActionCreators} from "redux";

import {FirebaseUtils, strings, CCButton, CCIcon,  CCActions} from './../../cc-imports'
import {colors} from "../../cc-imports";

class AddCoins extends Component {

    static propTypes = {}

    static defaultProps = {}

    constructor(props) {
        super(props)
        this.state = {
            screen:'more'
        }
        // this._openInviteFriends=this._openInviteFriends.bind(this);
        // this._claimDailyLoginBonus=this._claimDailyLoginBonus.bind(this);
    }

    componentDidMount(){

    }

    _changeScreen(screen){
        this.setState({screen : screen});
    }

    _openInviteFriends(){
        const {user}=this.props;
        if(user){
            FirebaseUtils.showInviteLinkDialog({'invitedBy':user.id}, user);
        }
    }

    // _openInviteFriends(){
    //     const {user}=this.props;
    //     if(user){
    //         FirebaseUtils.showInviteLinkDialog({'invitedBy':user.id}, user);
    //     }
    // }
    //
    // _claimDailyLoginBonus(){
    //     //console.log('onClaimPressed ---- ')
    //     const {user}=this.props;
    //     this.props.actions.claimDailyLoginBonus(user.id, user);
    // }

    render() {
        const {user, style} = this.props;
        return (
            <div style={{flex:1, flexDirection:'column'}}>
                <div style={{alignItems:'center', justifyContent:'center'}}>
                    <h2 style={{fontSize:20,alignItems:'center', justifyContent:'center',marginLeft:100, marginRight:100}}>{strings('earn_coins_bonuses')}</h2>
                </div>
                <div style={{flex:2,justifyContent:'center', alignItems : 'center'}}>
                    <h3 style={{marginBottom:10,alignItems:'center', justifyContent:'center',marginLeft:100, marginRight:100, fontSize:15}}>{strings('invite_friends')}</h3>
                    <CCIcon type={'inviteFriends'} height={80} width={80} style={{marginLeft:120, marginRight:100}} onClick={this._openInviteFriends} />
                    <h2 style={{marginTop:5,alignItems:'center', justifyContent:'center',marginLeft:100, marginRight:100, fontSize:15, textAlign:'center'}} >{strings('invite_friends_title')}</h2>
                </div>
                <div style={{ height:1, marginLeft:20, marginRight:20, flexDirection:'row',justifyContent:'center', alignItems:'center', marginTop:10, borderBottomColor:colors.theme2.border_color2, borderBottomWidth:0.5}}/>
                <div style={{flex:2,justifyContent:'center', alignItems : 'center'}}>
                    <h3  style={{marginBottom:10,alignItems:'center', justifyContent:'center',fontSize:15,marginLeft:100, marginRight:100}}>{strings('daily_login_bonus')}</h3>
                    <CCIcon type={'clock'} height={80} width={80} style={{marginLeft:100, marginRight:100, }} />
                </div>
            </div>
        )
    }
}

export default connect(state => ({
        // modals: state.modals,
        // user : state.user.user
    }),
    (dispatch) => ({
        actions: bindActionCreators({...CCActions}, dispatch),
        dispatch: dispatch
    })
)(AddCoins);


// WEBPACK FOOTER //
// ./src/app/screens/AddCoins/AddCoins.js